import type { IconData } from '@stacksjs/iconify-core'

export const star: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m10 13.554l3.517 1.85l-.672-3.917l2.846-2.774l-3.932-.571L10 4.579L8.241 8.142l-3.932.571l2.846 2.774l-.672 3.916zm0 2.26L3.827 19.06l1.179-6.875L.01 7.317l6.902-1.003L10 .06l3.087 6.254l6.902 1.003l-4.995 4.868l1.18 6.875z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default star
